// ./src/components/features/Connectors/ConnectorTypeBadge.tsx
import React from "react";
import { Badge } from "@mantine/core";
import {
  CONNECTOR_TYPES,
  CONNECTOR_TYPE_LABELS,
} from "@/config/connectorCategories";

export interface ConnectorTypeBadgeProps {
  /** Type value */
  type: string | null | undefined;

  /** Badge size */
  size?: "xs" | "sm" | "md" | "lg" | "xl";

  /** Badge variant */
  variant?: "filled" | "light" | "outline" | "dot" | "default";
}

// Colors for different types
const TYPE_COLORS: Record<string, string> = {
  [CONNECTOR_TYPES.HTTP]: "blue",
  [CONNECTOR_TYPES.FTP]: "cyan",
  [CONNECTOR_TYPES.FTPS]: "cyan",
  [CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_BLOB]: "violet",
  [CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_QUEUE]: "violet",
  [CONNECTOR_TYPES.SLACK]: "grape",
  [CONNECTOR_TYPES.TELEGRAM]: "teal",
  [CONNECTOR_TYPES.HUBSPOT]: "orange",
};

export const ConnectorTypeBadge: React.FC<ConnectorTypeBadgeProps> = ({
  type,
  size = "sm",
  variant = "light",
}) => {
  if (!type) {
    return (
      <Badge color="gray" size={size} variant={variant}>
        Unknown
      </Badge>
    );
  }

  const label = CONNECTOR_TYPE_LABELS[type] || type;
  const color = TYPE_COLORS[type] || "gray";

  return (
    <Badge color={color} size={size} variant={variant}>
      {label}
    </Badge>
  );
};
